import { render, staticRenderFns } from "./Territory.vue?vue&type=template&id=e1621560&scoped=true&"
import script from "./Territory.vue?vue&type=script&lang=js&"
export * from "./Territory.vue?vue&type=script&lang=js&"
import style0 from "./Territory.vue?vue&type=style&index=0&id=e1621560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1621560",
  null
  
)

export default component.exports